export default "__VITE_ASSET__mQAHqLW8__"